<template lang="pug">
.pickup-delivery
  v-row.px-5
    v-col.px-7(cols="12")
      h2.pa-4.primary--text {{ $t('Order.procurement') }}
  //- Date Range Selectors
  v-row.px-5
    v-col(cols="6")
      app-daterange-picker(
        :type="$t('Common.pickup')",
        :datetimeFrom.sync="instance.datePickupFrom",
        :datetimeTo.sync="instance.datePickupTo",
        :specificTime.sync="instance.specificPickupTime",
        :errors="errors",
        parentName="order"
      )
    v-col(cols="6")
      app-daterange-picker(
        :type="$t('Common.delivery')",
        :datetimeFrom.sync="instance.dateDeliveryFrom",
        :datetimeTo.sync="instance.dateDeliveryTo",
        :specificTime.sync="instance.specificDeliveryTime",
        :errors="errors",
        parentName="order"
      )
  //- Party Contacts From
  v-row.px-5
    v-col(cols="12")
      app-party-contacts(
        v-model="orderContactsFrom",
        type="From",
        v-bind="{...slotProps, showInfo: true}",
        vertical,
        :entity="$findEntity('Party')",
        path="partyFrom",
        :extra-load="['PartyFrom.ContactParties.Contact']",
        entityAlias="OrderContact",
      )
  v-row.px-5
    v-col(cols="12")
      app-party-contacts(
        v-model="orderContactsTo",
        type="To",
        v-bind="{...slotProps, showInfo: true}",
        vertical,
        :entity="$findEntity('Party')",
        path="partyTo",
        :extra-load="['PartyTo.ContactParties.Contact']",
        entityAlias="OrderContact",
      )
</template>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    slotProps: null,
  },
  data: () => ({
    _orderContactsTo: [],
    _orderContactsFrom: [],
  }),
  computed: {
    disablePickupTime() {
      return !this.instance.specificPickupTime;
    },
    disableDeliveryTime() {
      return !this.instance.specificDeliveryTime;
    },
    orderContactsFrom:{
      get () {
        if(this.instance.orderContacts){
          this._orderContactsFrom = this.instance.orderContacts.filter(x => x.contactType == 0)
          return this._orderContactsFrom;
        }
      },
      set (value) {
        this.instance.orderContacts =  this._orderContactsTo.concat(value)
      }
    },
    orderContactsTo:{
      get () {
        if(this.instance.orderContacts){
          this._orderContactsTo = this.instance.orderContacts.filter(x => x.contactType == 1)
          return this._orderContactsTo;
        }
      },
      set (value) {
        this.instance.orderContacts =  this._orderContactsFrom.concat(value)
      }
    },
  }
}
</script>
